module.exports = __webpack_public_path__ + "static/media/back_arrow.4cd0e792.svg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/reco/src/back_arrow.svg
// module id = 567
// module chunks = 0